module.exports = __webpack_public_path__ + "media/soundtrack.804a381c.mp3";